import { render } from "./consentFormList.vue?vue&type=template&id=456a3956&scoped=true"
import script from "./consentFormList.js?vue&type=script&lang=js"
export * from "./consentFormList.js?vue&type=script&lang=js"

import "./consentFormList.vue?vue&type=style&index=0&id=456a3956&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-456a3956"]])

export default __exports__